import React from 'react';
import styled, { css } from 'styled-components';
import illustrations from '../../../Illustration/components';
import Illustration from '../../../Illustration';
import ProgressiveImgIx from '../../../ProgressiveImgIx';

export type Props = {
  dataTestId?: string;
  icon: { src: string };
  illustration?: keyof typeof illustrations;
  width: number;
};

const TriggerIcon: React.FC<Props> = ({ icon, illustration, width }) =>
  illustration ? (
    <StyledIllustration $size={width} name={illustration} />
  ) : (
    <ProgressiveImgIx width={width} src={icon.src} />
  );

const StyledIllustration = styled(Illustration)<{ $size: number }>(
  ({ theme, $size }) => css`
    svg {
      height: ${$size}px;
      width: ${$size}px;
      color: ${theme.color('primary', 'text')};
    }
  `,
);

export default TriggerIcon;
